module.exports = __webpack_public_path__ + "static/axe_static-6fa1d7c169f11546ba7b81d2f1b7ad99.png";